export default __webpack_public_path__ + "static/media/juli_jatek_lufi.d308fbc9.png";